import React, { useState, useEffect } from 'react';

// Import CSS & assets
import ico_close from '../../../../assets/ico/ico_close.svg';



const DocIdItem = ({ capacity, docIdItem, docIdItem_index, docIdRef_Update, docIdRef_Delete }) => {

    const [isDelete, setIsDelete] = useState(false);


    const handleClickDelete = () => {
        setIsDelete(true);
    }

    const handleLibelleChange = (newLibelle) => {
        if (docIdItem !== newLibelle) {
            docIdRef_Update(docIdItem_index, newLibelle);
        }
    }



    return (
        <div className="app__ruleset_zoneUrba2_container_main">
            <div className="app__ruleset_zoneUrba2_container_left">
                <input className="app__ruleset_zoneUrba2_label_input" type="text" name="title" placeholder="ID de la référence" onChange={(e) => { }} onBlur={(e) => { handleLibelleChange(e.target.value) }} defaultValue={docIdItem}></input>
            </div>
            <div className="app__ruleset_zoneUrba2_container_right">
                <div className="app__ruleset_title_button_container" onClick={() => { handleClickDelete() }}>
                    <img src={ico_close} alt="dots" />
                </div>
            </div>
            {docIdItem === capacity?.rules?.gpu_data?.document?.id &&
                <>
                    <div className="app__ruleset_zoneUrba2_mask_full"></div>
                    <div className="app__ruleset_zoneUrba2_mask2"></div>
                </>
            }
            {isDelete &&
                <div className="app__ruleset_title_actions_container">
                    <div className="app__bound_type_modify_title_big" style={{ color: "#062134", fontWeight: "600", margin: "0px" }}>Supprimer cette référence ?</div>
                    <div className="app__ruleset_document_deletion_container" style={{ width: "300px" }}>
                        <div className="app__landsvalidation_popup_button" onClick={() => { setIsDelete(false) }}>Conserver</div>
                        <div className="app__landsvalidation_popup_button_second" onClick={() => { docIdRef_Delete(docIdItem_index) }}>Supprimer</div>
                    </div>
                </div>
            }
        </div>
    );
};

export default DocIdItem;